import * as z from "zod";
import { bundleInfoSchema } from "./bundle-info";

export const createBundle = {
  name: "createBundle" as const,
  input: z.object({
    parentVariantId: z.string().min(1),
    partVariantIds: z.array(z.string().min(1)).min(1).max(200),
  }),
  output: bundleInfoSchema,
};
